import { useState } from "react";
import './CompanySlider.css';
import alpineLogo from '../../Assets/associateCompany/alpine.jpg';
import alsideLogo from '../../Assets/associateCompany/alside.jpg';
import andersonLogo from '../../Assets/associateCompany/anderson.png';
import gafLogo from '../../Assets/associateCompany/Gaf.png';
import ikoLogo from '../../Assets/associateCompany/iko.png';
import marvinLogo from '../../Assets/associateCompany/marvin.png';
import milgardLogo from '../../Assets/associateCompany/milgard.png';
import owensLogo from '../../Assets/associateCompany/owensCorning.png';
import pellaLogo from '../../Assets/associateCompany/pella.png';
import windsorLogo from '../../Assets/associateCompany/windsor.png';
import arrow from '../../Assets/next.png';

const slides = [
  {url: alpineLogo, title: "Alpine company logo"},
  {url: alsideLogo, title: "Alside company logo"},
  {url: andersonLogo, title: "Anderson company logo"},
  {url: gafLogo, title: "Gaf company logo"},
  {url: ikoLogo, title: "IKO company logo"},
  {url: marvinLogo, title: "Marvin company logo"},
  {url: milgardLogo, title: "Milgard company logo"},
  {url: owensLogo, title: "Owens Corning company logo"},
  {url: pellaLogo, title: "Pella company logo"},
  {url: windsorLogo, title: "Windsor company logo"}
]
const slideStyles = {
  width: "100%",
  height: "100%",
  borderRadius: "10px",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const CompanySlider = () => {
  const slides = [
    {url: alpineLogo, title: "Alpine company logo"},
    {url: alsideLogo, title: "Alside company logo"},
    {url: andersonLogo, title: "Anderson company logo"},
    {url: gafLogo, title: "Gaf company logo"},
    {url: ikoLogo, title: "IKO company logo"},
    {url: marvinLogo, title: "Marvin company logo"},
    {url: milgardLogo, title: "Milgard company logo"},
    {url: owensLogo, title: "Owens Corning company logo"},
    {url: pellaLogo, title: "Pella company logo"},
    {url: windsorLogo, title: "Windsor company logo"}
  ]
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  const goToNext = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };
  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };
  const slideStylesWidthBackground = {
    ...slideStyles,
    backgroundImage: `url(${slides[currentIndex].url})`,
  };

  return (
    <div className="sliderStyles">
      <div>
        <div onClick={goToPrevious} className="leftArrowStyles">
          <img className="leftArrow"  src={arrow} alt=""/>
        </div>
        <div onClick={goToNext} className="rightArrowStyles">
          <img className="rightArrow"  src={arrow} alt=""/>
        </div>
      </div>
      <div style={slideStylesWidthBackground}></div>
      <div className="dotsContainerStyles">
        {slides.map((slide, slideIndex) => (
          <div
            className="dotStyle"
            key={slideIndex}
            onClick={() => goToSlide(slideIndex)}
          >
            ●
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanySlider;
